<template>

<form
  class="mx-auto col-sm-8"
  @submit.prevent
>
  <div class="col">
    <div class="form-group">
      <label for="location">{{ $t('location') }}</label>
      <Combobox
        disabled
        class="bg-white"
        name='location'
        :hasErrors="errors.has('location')"
        :placeholder="$t('select_a_item')"
        label="name"
        :options="locations"
        :initial-value="activeStatusDefault.location"
        v-model="activeStatusDefault.location"
      />
    </div>

    <div class="form-group">
      <label for="status">{{ $t('status') }}</label>
      <Combobox
        class="bg-white"
        name='status'
        :hasErrors="errors.has('status')"
        :placeholder="$t('select_a_item')"
        label="name"
        :options="allStatus.rows"
        :initial-value="activeStatusDefault.status"
        :reduce="status => status.id"
        v-model="activeStatusDefault.status"
        v-validate="'required'"
      />

      <small v-show="errors.has('status')" class="form-text">
        {{ errors.first('status') }}
      </small>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton
          @click="save"
        >
          {{ $t('save') }}
        </LoaderButton>
      </div>
    </div>
  </div>
</form>

</template>

<script>
import { mapState } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import { request } from '@/lib/http'
import allLocations from '@/config/locations'

export default {
  name: 'MovementTypeForm',
  components: {
    LoaderButton,
    Combobox
  },

  data() {
    return {
      locations: allLocations,
      activeStatusDefault: {
        id      : undefined,
        location: 'OFICINA CREDENCIADA',
        status  : undefined
      }
    }
  },

  computed: {
    ...mapState({
      allStatus: state => state.status.all
    })
  },

  methods: {
    async save () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const { dispatch } = this.$store
      
      dispatch('overlay/show', true)

      try {
        await request({
          url   : `edit-default-activestatus-removed/${this.activeStatusDefault.id}`,
          method: 'patch',
          data  : this.activeStatusDefault
        })
        
      } catch (error) {
        
      } finally {
        dispatch('overlay/show', false)
      }      
    }
  },

  async mounted() {
    const { dispatch } = this.$store

    dispatch('overlay/show', true)

    await dispatch('status/fetchAll')

    const { status, id } = await request({
      url: 'default-activestatus-removed',
      method: 'get'
    })

    this.activeStatusDefault.id = id
    this.activeStatusDefault.status = status.id
    
    dispatch('overlay/show', false)
  }
}
</script>